var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { TypeActionLeagueInfo } from "./actionPlayerLeagueInfo";
var initial = {
    leagues: new Map(),
};
export var reducerLeagueInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionLeagueInfo.Received && action.leagueInfo !== undefined) {
        state.leagues.set(action.leagueId, __assign({}, state.leagues.get(action.leagueId), action.leagueInfo));
        return state;
    }
    switch (action.type) {
        case TypeActionLeagueInfo.SetPoints: {
            initializeEventProgressSafe(state, action.leagueId);
            var leagues = state.leagues;
            var updatedLeague = leagues.get(action.leagueId);
            updatedLeague.eventProgress.points = action.points;
            return __assign({}, state, { leagues: leagues });
        }
        case TypeActionLeagueInfo.AddPoints: {
            var existingPoints = getPointsSafe(state, action.leagueId);
            var leagues = state.leagues;
            var updatedLeague = leagues.get(action.leagueId);
            updatedLeague.eventProgress.points = existingPoints.add(action.points);
            leagues.set(action.leagueId, updatedLeague);
            return __assign({}, state, { leagues: leagues });
        }
        case TypeActionLeagueInfo.SelectLeague: {
            return __assign({}, state, { selectedLeague: action.leagueId });
        }
        case TypeActionLeagueInfo.DeselectLeague: {
            return __assign({}, state, { selectedLeague: undefined });
        }
    }
    return state;
};
var getPointsSafe = function (state, eventId) {
    var eventProgress = initializeEventProgressSafe(state, eventId);
    if (eventProgress.points == undefined) {
        eventProgress.points = Long.ZERO;
    }
    return eventProgress.points;
};
var initializeEventProgressSafe = function (state, eventId) {
    var event = initializeEventIdSafe(state, eventId);
    if (event.eventProgress == undefined) {
        event.eventProgress = {};
    }
    return event.eventProgress;
};
var initializeEventIdSafe = function (state, eventId) {
    if (!state.leagues.has(eventId)) {
        state.leagues.set(eventId, {});
    }
    return state.leagues.get(eventId);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/league/reducerPlayerLeagueInfo.ts
// module id = 2535
// module chunks = 3